import {TFunction} from 'i18next'
import React from 'react'

import {WorkCenterSearchHierarchy} from './WorkCenterSearchHierarchy'

import {WorkCenter} from '@hconnect/common/types'

export type WorkCenterSearchContainerProps = {
  label?: React.ReactNode
  errorText?: React.ReactNode
  required?: boolean
  t: TFunction
  workCenters: WorkCenter[]
  handleWorkCenterSelection: (workCenter: WorkCenter | undefined) => void
  workCenter: WorkCenter | undefined
}

export const WorkCenterSearchContainer = (props: WorkCenterSearchContainerProps) => {
  return (
    <WorkCenterSearchHierarchy
      data-test-id="work-center-search-dropdown"
      errorText={props.errorText}
      t={props.t}
      onChange={(value) => props.handleWorkCenterSelection(value)}
      value={props.workCenter}
      required={props.required}
      workCenters={props.workCenters}
    />
  )
}
